export const errorMapping: { [key: number]: { message: string; description: string } } = {
    400: {
        message: 'Invalid ZIP Code entered',
        description: 'Please enter a valid ZIP Code.',
    },
    401: {
        message: 'Status: 401 - Authentication required',
        description: 'Please refresh the page and try again.',
    },
    404: {
        message: 'Status: 404 - Authentication required',
        description: 'Please refresh the page and try again.',
    },
    500: {
        message: 'Internal server error',
        description: 'Please refresh the page and try again.',
    },
};
